module.exports = __webpack_public_path__ + "static/media/view syllabus template.8de048d3.svg";